var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat; // @TODO: handle scaping, single/double quotes, etc.


var StringLiteral = {
  print: function print(_ref) {
    var node = _ref.node;
    return concat(['"', node.value, '"']);
  }
};
module.exports = StringLiteral;